import { Logger, ScriptDependency, CssDependency } from '../sgvizler';
/**
 * Todo
 *
 * @class sgvizler.visualization.Loader
 * @memberof sgvizler.visualization
 */
export class Loader {
    static on(event, fn) {
        if (event === 'loaded') {
            Loader._listCallEvent.push(fn);
        }
    }
    static detectRoot() {
        let resultXpath = document.evaluate('//script[contains(@src,"sgvizler2.js")]/@src', document, null, XPathResult.STRING_TYPE, null);
        let srcScript = resultXpath.stringValue;
        let match = /^(.*)sgvizler2\.js$/.exec(srcScript);
        if (match) {
            Loader._pathScripts = match[1];
        }
    }
    static isLoad(dep) {
        return Loader._load.indexOf(dep.url) !== -1;
    }
    static isLoaded(dep) {
        return Loader._loaded.indexOf(dep.url) !== -1;
    }
    static load(dep) {
        if (dep instanceof ScriptDependency) {
            Loader.loadScript(dep);
        }
        else if (dep instanceof CssDependency) {
            Loader.loadCss(dep);
        }
    }
    static fireEvent(event) {
        for (let call of Loader._listCallEvent) {
            call(event);
        }
    }
    static checkDependenciesToLoad() {
        //filter doublons
        Loader._dependenciesToLoad = Loader._dependenciesToLoad.filter((v, i, a) => a.indexOf(v) === i);
        let len = Loader._dependenciesToLoad.length;
        for (let i = 0; i < len; i++) {
            let dep = Loader._dependenciesToLoad[i];
            if (dep === undefined || Loader.isLoaded(dep)) {
                //this._dependenciesToLoad.splice(i)
                delete this._dependenciesToLoad[i];
            }
        }
        Loader._dependenciesToLoad.forEach((dep) => {
            if (dep instanceof ScriptDependency) {
                Loader.loadScript(dep);
            }
            else if (dep instanceof ScriptDependency) {
                Loader.loadCss(dep);
            }
        });
    }
    static getAbsoluteURL(url) {
        if (url.match(/^(\/\/|https?)/)) {
            return url;
        }
        else {
            return Loader._pathScripts + url;
        }
    }
    static loadScript(dep) {
        let url = dep.url;
        return new Promise(function (resolve, reject) {
            if (dep.loadBefore && !dep.loadBefore.endDownload) {
                //Logger.logSimple('Waiting : ' + dep.loadBefore.url + ' before ' + dep.url)
                Loader._dependenciesToLoad.push(dep);
                Loader.load(dep.loadBefore);
                return resolve();
            }
            // include script only once
            if (Loader.isLoad(dep)) {
                return resolve(); // false;
            }
            else {
                Loader._load.push(url);
            }
            Logger.logSimple('Loading : ' + dep.url);
            // Adding the script tag to the head as suggested before
            let head = document.getElementsByTagName('head')[0];
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = Loader.getAbsoluteURL(url);
            // Then bind the event to the callback function.
            // There are several events for cross browser compatibility.
            script.onload = function () {
                Loader._loaded.push(url); // in first
                dep.callBack();
                // remember included script
                Loader.fireEvent('loaded');
                Loader.checkDependenciesToLoad();
            };
            // Fire the loading
            head.appendChild(script);
        });
    }
    static loadCss(dep) {
        let url = dep.url;
        return new Promise(function (resolve, reject) {
            if (dep.loadBefore && !dep.loadBefore.endDownload) {
                Loader._dependenciesToLoad.push(dep);
                Loader.load(dep.loadBefore);
                return resolve();
            }
            // include script only once
            if (Loader.isLoad(dep)) {
                return resolve(); // false;
            }
            else {
                Loader._load.push(url);
            }
            // <link rel="stylesheet" type="text/css" href="../dist/datatables.min.css"/>
            let head = document.getElementsByTagName('head')[0];
            let link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = Loader.getAbsoluteURL(url);
            // Then bind the event to the callback function.
            // There are several events for cross browser compatibility.
            link.onload = function () {
                Loader._loaded.push(url);
                Logger.logSimple('Loaded : ' + url);
                dep.callBack();
                // remember included script
                Loader.fireEvent('loaded');
                Loader.checkDependenciesToLoad();
            };
            // Fire the loading
            head.appendChild(link);
        });
    }
}
Loader._load = [];
Loader._loaded = [];
Loader._dependenciesToLoad = [];
Loader._pathScripts = '';
Loader._listCallEvent = [];
//# sourceMappingURL=data:application/json;base64,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